export default {"src":"/_next/static/media/mkr.62d52ece.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};